import React, { useState, useEffect } from "react";

function ShopTitleButtons() {
    const currentUrl = window.location.href;
    const parsedUrl = new URL(currentUrl);
    const category = parsedUrl.searchParams.get("category");

    const initialButtons = [
        { label: "ГЛАВНАЯ", link: "../../../../ucp/shop?category=main", category: "main" },
        { label: "PREMIUM", link: "../../../../ucp/shop?category=premium", category: "premium" },
        { label: "АКССЕСУАРЫ", link: "../../../../ucp/shop?category=accessories", category: "accessories" },
        { label: "ТОРГОВАЯ ПЛОЩАДКА", link: "#" },
        { label: "КУПОНЫ", link: "../../../../ucp/shop?category=coupons", category: "coupons" },
    ];

    const nextButtons = [
        { label: "КОСТЮМЫ", link: "../../../../ucp/shop?category=costumes", category: "costumes" },
        { label: "ОРУЖИЕ", link: "../../../../ucp/shop?category=weapons", category: "weapons" },
        { label: "НАБОРЫ", link: "../../../../ucp/shop?category=kits", category: "kits" },
        { label: "ЛАРЦЫ", link: "../../../../ucp/shop?category=boxes", category: "boxes" },
        { label: "КАБАРЕ", link: "../../../../ucp/shop?category=cabarets", category: "cabarets" },
        { label: "ПРОЧЕЕ", link: "../../../../ucp/shop?category=other", category: "other" },
    ];

    const allCategories = [...initialButtons, ...nextButtons].map(btn => btn.category);

    const [activeCategory, setActiveCategory] = useState(category || "main");
    const [isNext, setIsNext] = useState(nextButtons.some(btn => btn.category === activeCategory));

    useEffect(() => {
        setActiveCategory(category || "main");
        setIsNext(nextButtons.some(btn => btn.category === category));
    }, [category]);

    const handleShift = () => {
        setIsNext(!isNext);
    };

    const handleClick = (category) => {
        setActiveCategory(category);
        setIsNext(nextButtons.some(btn => btn.category === category));
        window.location.href = `../../../../ucp/shop?category=${category}`;
    };

    return (
        <div className='ucp-header shop-title-buttons-wrapper'>
            {isNext && (
                <button className='ucp-simple-blur-button ucp-button-back button-back-title-shop fade-in-out' onClick={handleShift}>
                    НАЗАД
                </button>
            )}
            {(isNext ? nextButtons : initialButtons).map((btn, index) => (
                <button
                    key={index}
                    className={`ucp-simple-blur-button shop-title-buttons fade-in-out ${btn.category === activeCategory ? "active" : ""}`}
                    onClick={() => handleClick(btn.category)}
                >
                    {btn.label}
                </button>
            ))}
            {!isNext && (
                <button className='ucp-simple-blur-button shop-title-buttons ucp-button-back shop-title-button-next fade-in-out' onClick={handleShift}>
                    ДАЛЕЕ
                </button>
            )}
        </div>
    );
}

export default ShopTitleButtons;
